<template>
  <div :class="$store.state.IsLittleScreen ? 'little-screen' : 'gfmoney-box'" ref="pageRef">
    <div v-if="!$store.state.IsLittleScreen">
      <m-header></m-header>
      <swiper id="banner-swiper" class="banner-swiper" :options="swiperBanner">
        <swiper-slide v-for="inner in bannerList" :key="inner.bannerId" class="banner-swiper-item">
          <div class="banner-swiper-item-box" @click="goBanner(inner)">
            <div class="banner-img" :style="{
              backgroundImage: `url(${linkAllImgUrl(inner.imageUrl)})`
            }"></div>
          </div>
        </swiper-slide>
      </swiper>
      <div id="money-box" class="money-box">
        <div class="menu-box" :class="headerFixed ? 'isFixed' : 'noFixed'">
          <div class="menu-list">
            <div @click="menuClick(1)" class="menu-item flex align-center justify-between"
              :class="active === 1 ? 'menu-active' : 'menu-default'">
              <div>首页</div>
              <img style="width: 5px;height: 10px;" src="../assets/gfMoney/right-icon.png">
            </div>
            <div @click="menuClick(2)" class="menu-item flex align-center justify-between"
              :class="active === 2 ? 'menu-active' : 'menu-default'">
              <div>红包总金额</div>
              <img style="width: 5px;height: 10px;" src="../assets/gfMoney/right-icon.png">
            </div>
            <div @click="menuClick(3)" class="menu-item flex align-center justify-between"
              :class="active === 3 ? 'menu-active' : 'menu-default'">
              <div>我的任务进度</div>
              <img style="width: 5px;height: 10px;" src="../assets/gfMoney/right-icon.png">
            </div>
            <div @click="menuClick(4)"
              v-if="activityInfo.rankWeekOpen == 1 || activityInfo.rankTotalOpen == 1 || activityInfo.rankTxOpen == 1"
              class="menu-item flex align-center justify-between" :class="active === 4 ? 'menu-active' : 'menu-default'">
              <div>提现排行榜</div>
              <img style="width: 5px;height: 10px;" src="../assets/gfMoney/right-icon.png">
            </div>
            <div @click="menuClick(5)" class="menu-item flex align-center justify-between"
              :class="active === 5 ? 'menu-active' : 'menu-default'">
              <div>好友任务进度</div>
              <img style="width: 5px;height: 10px;" src="../assets/gfMoney/right-icon.png">
            </div>
            <div @click="menuClick(6)" class="menu-item flex align-center justify-between"
              :class="active === 6 ? 'menu-active' : 'menu-default'">
              <div>活动介绍及规则</div>
              <img style="width: 5px;height: 10px;" src="../assets/gfMoney/right-icon.png">
            </div>
          </div>
        </div>
        <div class="info-box flex flex-direction align-center">
          <img class="title-img" src="../assets/gfMoney/title_hb.png">
          <img style="width: 258px;height: 258px;margin-top: 22px" src="../assets/gfMoney/money_num.png">
          <div class="sy-box flex align-center justify-center">
            <img style="width: 30px;height: 32px;margin-right: 20px" src="../assets/gfMoney/money-icon.png">
            <div>剩余瓜分金额：¥{{ money }}.00</div>
          </div>
          <div class="invite-box flex align-center justify-between">
            <div class="flex align-center " style="padding-left: 20px">
              <img style="width: 48px;height: 48px;margin-right: 23px" src="../assets/gfMoney/invite-code.png">
              <div class="invite-code-text" v-if="GET_USER_INFO.token">邀请码：{{ GET_USER_INFO.inviteCode }}</div>
              <div class="invite-code-text" @click="goLogin" style="cursor: pointer" v-else>邀请码：<span
                  style="font-size: 16px">请登录后查看 !</span></div>
            </div>
            <div class="flex align-center justify-center invite-copy" @click="copyInviteUrl">
              <img style="width: 16px;height: 17px;margin-right: 20px" src="../assets/gfMoney/copy.png">
              <div>复制邀请码链接</div>
            </div>
          </div>
        </div>
      </div>
      <div id="mission-box" class="mission-box flex flex-direction align-center">
        <div class="mission-title">我的任务进度</div>
        <div class="mission-in-box flex flex-direction align-center">
          <div class="line-box" v-if="GET_USER_INFO.token">
            <div class="process-line" :style="{ width: prcentNum + '%' }"></div>
            <div class="percent" :style="{ left: prcentNum + '%' }">{{ prcentNum }}%</div>
            <div class="money-point" :style="{ left: 'calc(' + prcentNum + '% - 20px)' }">{{ avUserInfo.currentMoney ?
              avUserInfo.currentMoney : 0 }}元<div class="sj-sk"></div>
            </div>
          </div>
          <div class="line-box" v-if="!GET_USER_INFO.token">
            <div class="process-line" :style="{ width: '0%' }"></div>
            <div class="percent" :style="{ left: '0%' }">0%</div>
            <div class="money-point" @click="goLogin" :style="{ left: '0px)' }" style="font-size: 14px;cursor: pointer">
              请先登录<div class="sj-sk"></div>
            </div>
          </div>
          <div class="tx-message" style="background-color: #9e8080" v-if="activityInfo.txOpen != 1">暂未开放提现，请等待！</div>
          <div class="tx-message-tx" v-if="showTx && activityInfo.txOpen == 1" @click="toTx()">立即提现</div>
          <div class="tx-message" v-if="!showTx && activityInfo.txOpen == 1">到达{{ activityInfo.txMoney }}元即可提现</div>
          <div class="flex align-center justify-center" style="margin-top: 45px;cursor: pointer" @click="toLucky()">
            <img style="width: 21px;height: 24px;margin-right: 12px" src="../assets/gfMoney/prize-cj.png">
            <div class="prize-text">抽奖轮盘</div>
            <div class="circle"></div>
          </div>
          <div class="notice flex align-center">
            <img style="width: 32px;height: 29px;margin-right: 21px" src="../assets/gfMoney/notice.png">
            <van-notice-bar scrollable :text="activityInfo.notice" color="red" background="#FFF8E5" style="width: 100%;"
              :speed="40" />
          </div>
        </div>
      </div>

      <div id="tx-box" class="tx-box flex flex-direction align-center" style="padding-top: 76px"
        v-if="activityInfo.rankWeekOpen == 1 || activityInfo.rankTotalOpen == 1 || activityInfo.rankTxOpen == 1">
        <img style="width: 160px;" src="../assets/gfMoney/title-tx.png">
        <div class="tx-rank">
          <div class="flex align-center" style="height: 404px;padding-left: 62px" v-if="activityInfo.rankWeekOpen == 1">
            <div class="flex align-center">
              <img style="width: 60px;height: 60px;margin-right: 16px" src="../assets/gfMoney/week.png">
              <div class="rank-name">周榜</div>
            </div>
            <div class="s-line"></div>
            <div class="rank-list">
              <div class="rank-item flex align-center" v-for="(item, index) in weekRankList">
                <div class="flex align-center justify-center" style="width: 28px;height: 32px;margin-right: 28px">
                  <img style="width: 28px;height: 32px" v-if="index === 0" src="../assets/gfMoney/num1.png">
                  <img style="width: 28px;height: 32px" v-if="index === 1" src="../assets/gfMoney/num2.png">
                  <img style="width: 28px;height: 32px" v-if="index === 2" src="../assets/gfMoney/num3.png">
                  <div v-if="index > 2" class="rank-num">{{ index + 1 }}</div>
                </div>
                <el-avatar :size="40" icon="el-icon-user-solid"
                  :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                <div class="username text-line-1">{{ hiddenStr(item.fullName) }}</div>
                <div class="">
                  <span class="label">已上传：</span>
                  <span class="value">{{ item.uploadNum }}个模型</span>
                </div>
                <div class="">
                  <span class="label">已瓜分：</span>
                  <span class="value" style="color:#FA5C5C;">¥{{ item.totalMoney }}.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex align-center" style="height: 404px;margin-top: 32px;padding-left: 62px"
            v-if="activityInfo.rankTotalOpen == 1">
            <div class="flex align-center">
              <img style="width: 60px;height: 60px;margin-right: 16px" src="../assets/gfMoney/total.png">
              <div class="rank-name">总榜</div>
            </div>
            <div class="s-line"></div>
            <div class="rank-list">
              <div class="rank-item flex align-center" v-for="(item, index) in uploadRankList">
                <div class="flex align-center justify-center" style="width: 28px;height: 32px;margin-right: 28px">
                  <img style="width: 28px;height: 32px" v-if="index === 0" src="../assets/gfMoney/num1.png">
                  <img style="width: 28px;height: 32px" v-if="index === 1" src="../assets/gfMoney/num2.png">
                  <img style="width: 28px;height: 32px" v-if="index === 2" src="../assets/gfMoney/num3.png">
                  <div v-if="index > 2" class="rank-num">{{ index + 1 }}</div>
                </div>
                <el-avatar :size="40" icon="el-icon-user-solid"
                  :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                <div class="username text-line-1">{{ hiddenStr(item.fullName) }}</div>
                <div class="">
                  <span class="label">已上传：</span>
                  <span class="value">{{ item.uploadNum }}个模型</span>
                </div>
                <div class="">
                  <span class="label">已瓜分：</span>
                  <span class="value" style="color:#FA5C5C;">¥{{ item.totalMoney }}.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex align-center" style="height: 404px;margin-top: 32px;padding-left: 62px"
            v-if="activityInfo.rankTxOpen == 1">
            <div class="flex align-center">
              <img style="width: 60px;height: 60px;margin-right: 16px" src="../assets/gfMoney/total.png">
              <div class="rank-name">提现榜</div>
            </div>
            <div class="s-line"></div>
            <div class="rank-list">
              <div class="rank-item flex align-center" v-for="(item, index) in totalRankList">
                <div class="flex align-center justify-center" style="width: 28px;height: 32px;margin-right: 28px">
                  <img style="width: 28px;height: 32px" v-if="index === 0" src="../assets/gfMoney/num1.png">
                  <img style="width: 28px;height: 32px" v-if="index === 1" src="../assets/gfMoney/num2.png">
                  <img style="width: 28px;height: 32px" v-if="index === 2" src="../assets/gfMoney/num3.png">
                  <div v-if="index > 2" class="rank-num">{{ index + 1 }}</div>
                </div>
                <el-avatar :size="40" icon="el-icon-user-solid"
                  :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                <div class="username text-line-1">{{ hiddenStr(item.fullName) }}</div>
                <div class="">
                  <span class="label">已上传：</span>
                  <span class="value">{{ item.uploadNum }}个模型</span>
                </div>
                <div class="">
                  <span class="label">已瓜分：</span>
                  <span class="value" style="color:#FA5C5C;">¥{{ item.totalMoney }}.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="jd-box" class="jd-box flex flex-direction align-center" style="padding-top: 44px">
        <img style="width: 128px;" src="../assets/gfMoney/title-jd.png">
        <div class="hy-list">
          <div class="invite-num">好友任务进度 <span style="font-weight: normal;color:#999999;margin-left: 28px"
              v-if="GET_USER_INFO.token">{{ inviteNum }}/10</span></div>
          <div class="flex flex-wrap align-center justify-between" style="position: relative">
            <div class="invite-item" v-for="(item, index) in inviteList" :key="index" @click="copyInviteUrl">
              <div class="flex align-center justify-between">
                <div class="flex align-center">
                  <el-avatar v-if="item.fullName" :size="40" icon="el-icon-user-solid"
                    :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                  <i style="font-size: 45px;color: #E5E5E5 " v-else class="el-icon-circle-plus"></i>
                  <div class="username text-line-1" style="margin-left: 9px">{{ item.fullName ? item.fullName : '待邀请' }}
                  </div>
                </div>
                <div class="money-jl" v-if="item.missionStep == 2">上传模型</div>
                <div class="money-jl" v-if="item.missionStep == 1">已注册</div>
                <div class="money-jl" v-if="item.missionStep == 3">邀请成功</div>
              </div>
              <div class="flex align-center justify-between" style="margin-top: 20px">
                <div class="p-line">
                  <div class="p-r-line" v-if="item.missionStep == 1" :style="{ width: '33%' }"></div>
                  <div class="p-r-line" v-else-if="item.missionStep == 2" :style="{ width: '66%' }"></div>
                  <div class="p-r-line" v-else-if="item.missionStep == 3" :style="{ width: '100%' }"></div>
                  <div class="p-r-line" v-else :style="{ width: '0%' }"></div>
                </div>
                <!--                <div class="percent-text" v-if="item.missionStep == 1">33%</div>-->
                <!--                <div class="percent-text" v-else-if="item.missionStep == 2">66%</div>-->
                <!--                <div class="percent-text" v-else-if="item.missionStep == 3">100%</div>-->
                <!--                <div class="percent-text" v-else >0%</div>-->
              </div>
            </div>
            <div class="no-login-mask flex align-center justify-center" v-if="!GET_USER_INFO.token">
              <div style="font-size: 14px;text-align: center;color: #FF0000;cursor: pointer">请登录后查看!</div>
              <el-button
                style="background-color: #FF0000;color: #FFFFFF;margin-left: 20px;border-radius: 20px;letter-spacing: 2px;font-weight: bold"
                @click="goLogin">登录</el-button>
            </div>
          </div>
        </div>
      </div>

      <div id="rule-box" class="rule-box flex flex-direction align-center" style="padding-top: 65px">
        <img style="width: 222px;" src="../assets/gfMoney/title-rule.png">
        <div class="rule-content" v-html="activityInfo.rule"></div>
      </div>

      <div class="tofb" @click="goFb">去发布模型作品</div>
      <m-footer></m-footer>

    </div>
    <div v-else>
      <div class="flex align-center top-box">
        <img class="logo-icon" src="~@/assets/logo-light.png" />
      </div>
      <van-swipe v-if="$store.state.IsLittleScreen" class="top-swiper" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="inner in bannerList" :key="inner.bannerId">
          <div class="banner-swiper-item-box" @click="goBanner(inner)">
            <img :src="linkAllImgUrl(inner.imageUrl)" style="width: 100%;">
          </div>
        </van-swipe-item>
      </van-swipe>
      <div id="money-box" class="money-box">
        <div class="info-box flex flex-direction align-center">
          <img class="title-img" src="../assets/gfMoney/title_hb.png">
          <img style="width: 130px;height: 130px;margin-top: 22px" src="../assets/gfMoney/money_num.png">
          <div class="sy-box flex align-center justify-center">
            <img style="width: 15px;height: 16px;margin-right: 10px" src="../assets/gfMoney/money-icon.png">
            <div>剩余瓜分金额：¥{{ money }}.00</div>
          </div>
          <div class="invite-box flex align-center justify-between" @click="copyInviteUrl">
            <div class="flex align-center " style="padding-left: 20px">
              <img style="width: 24px;height: 24px;margin-right: 12px" src="../assets/gfMoney/invite-code.png">
              <div class="invite-code-text" v-if="GET_USER_INFO.token">邀请码：{{ GET_USER_INFO.inviteCode }}</div>
              <div class="invite-code-text" @click.stop="goLogin" style="cursor: pointer" v-else>邀请码：<span
                  style="font-size: 8px">请登录后查看 !</span></div>
            </div>
            <div class="flex align-center justify-center invite-copy">
              <img style="width: 10px;height: 11px;margin-right: 10px" src="../assets/gfMoney/copy.png">
              <div>复制邀请码链接</div>
            </div>
          </div>
        </div>
      </div>
      <div id="mission-box" class="mission-box flex flex-direction align-center">
        <div class="mission-title">我的任务进度</div>
        <div class="mission-in-box flex flex-direction align-center">
          <div class="line-box" v-if="GET_USER_INFO.token">
            <div class="process-line" :style="{ width: prcentNum + '%' }"></div>
            <div class="percent" :style="{ left: 'calc(' + prcentNum + '%' + ' - 30px)' }">{{ prcentNum }}%</div>
            <div class="money-point" :style="{ left: 'calc(' + prcentNum + '% - 60px)' }">{{ avUserInfo.currentMoney ?
              avUserInfo.currentMoney : 0 }}元<div class="sj-sk"></div>
            </div>
          </div>
          <div class="line-box" v-if="!GET_USER_INFO.token">
            <div class="process-line" :style="{ width: '0%' }"></div>
            <div class="percent" :style="{ left: '0%' }">0%</div>
            <div class="money-point" @click="goLogin" :style="{ left: '0px)' }" style="font-size: 7px;cursor: pointer">请先登录
              <div class="sj-sk"></div>
            </div>
          </div>
          <div class="tx-message" style="background-color: #9e8080" v-if="activityInfo.txOpen != 1">暂未开放提现，请等待！</div>
          <div class="tx-message-tx" v-if="showTx && activityInfo.txOpen == 1" @click="toTx()">立即提现</div>
          <div class="tx-message" v-if="!showTx && activityInfo.txOpen == 1">到达{{ activityInfo.txMoney }}元即可提现</div>
          <div class="flex align-center justify-center" style="margin-top: 20px;cursor: pointer" @click="toLucky()">
            <img style="width: 12px;height: 12px;margin-right: 8x" src="../assets/gfMoney/prize-cj.png">
            <div class="prize-text">抽奖轮盘</div>
            <div class="circle"></div>
          </div>
          <div class="notice flex align-center">
            <img style="width: 16px;height: 16px;margin-right: 12px" src="../assets/gfMoney/notice.png">
            <van-notice-bar scrollable :text="activityInfo.notice" color="red" background="#FFF8E5" style="width: 100%;"
              :speed="40" />
          </div>
        </div>
      </div>
      <div id="tx-box" class="tx-box flex flex-direction align-center" style="padding-top: 30px"
        v-if="activityInfo.rankWeekOpen == 1 || activityInfo.rankTotalOpen == 1 || activityInfo.rankTxOpen == 1">
        <img style="width: 80px;" src="../assets/gfMoney/title-tx.png">
        <div class="tx-rank">
          <div class="flex flex-direction align-center" style="margin-top: 16px;" v-if="activityInfo.rankWeekOpen == 1">
            <div class="flex align-center">
              <img style="width: 30px;height: 30px;margin-right: 8px" src="../assets/gfMoney/week.png">
              <div class="rank-name">周榜</div>
            </div>
            <div class="rank-list">
              <div class="rank-item flex align-center" v-for="(item, index) in weekRankList">
                <div class="flex align-center justify-center" style="width: 14px;height: 16px;margin-right: 8px">
                  <img style="width: 14px;height: 16px" v-if="index === 0" src="../assets/gfMoney/num1.png">
                  <img style="width: 14px;height: 16px" v-if="index === 1" src="../assets/gfMoney/num2.png">
                  <img style="width: 14px;height: 16px" v-if="index === 2" src="../assets/gfMoney/num3.png">
                  <div v-if="index > 2" class="rank-num">{{ index + 1 }}</div>
                </div>
                <el-avatar :size="20" icon="el-icon-user-solid"
                  :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                <div class="username text-line-1">{{ hiddenStr(item.fullName) }}</div>
                <div class="flex align-center " style="width: 120px;">
                  <div class="label">已上传：</div>
                  <div class="value">{{ item.uploadNum }}个模型</div>
                </div>
                <div class="flex align-center" style="width: 100px;">
                  <div class="label">已瓜分：</div>
                  <div class="value" style="color:#FA5C5C;">¥{{ item.totalMoney }}.00</div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-direction align-center" v-if="activityInfo.rankTotalOpen == 1" style="margin-top: 16px;">
            <div class="flex align-center">
              <img style="width: 30px;height: 30px;margin-right: 8px" src="../assets/gfMoney/total.png">
              <div class="rank-name">总榜</div>
            </div>
            <div class="rank-list">
              <div class="rank-item flex align-center" v-for="(item, index) in uploadRankList">
                <div class="flex align-center justify-center" style="width: 14px;height: 16px;margin-right: 8px">
                  <img style="width: 14px;height: 16px" v-if="index === 0" src="../assets/gfMoney/num1.png">
                  <img style="width: 14px;height: 16px" v-if="index === 1" src="../assets/gfMoney/num2.png">
                  <img style="width: 14px;height: 16px" v-if="index === 2" src="../assets/gfMoney/num3.png">
                  <div v-if="index > 2" class="rank-num">{{ index + 1 }}</div>
                </div>
                <el-avatar :size="20" icon="el-icon-user-solid"
                  :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                <div class="username text-line-1">{{ hiddenStr(item.fullName) }}</div>
                <div class="flex align-center " style="width: 120px;">
                  <div class="label">已上传：</div>
                  <div class="value">{{ item.uploadNum }}个模型</div>
                </div>
                <div class="flex align-center" style="width: 100px;">
                  <div class="label">已瓜分：</div>
                  <div class="value" style="color:#FA5C5C;">¥{{ item.totalMoney }}.00</div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-direction align-center" v-if="activityInfo.rankTxOpen == 1" style="margin-top: 16px;">
            <div class="flex align-center">
              <img style="width: 30px;height: 30px;margin-right: 8px" src="../assets/gfMoney/total.png">
              <div class="rank-name">提现榜</div>
            </div>
            <div class="rank-list">
              <div class="rank-item flex align-center" v-for="(item, index) in totalRankList" :key="index">
                <div class="flex align-center justify-center" style="width: 14px;height: 16px;margin-right: 8px">
                  <img style="width: 14px;height: 16px" v-if="index === 0" src="../assets/gfMoney/num1.png">
                  <img style="width: 14px;height: 16px" v-if="index === 1" src="../assets/gfMoney/num2.png">
                  <img style="width: 14px;height: 16px" v-if="index === 2" src="../assets/gfMoney/num3.png">
                  <div v-if="index > 2" class="rank-num">{{ index + 1 }}</div>
                </div>
                <el-avatar :size="20" icon="el-icon-user-solid"
                  :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                <div class="username text-line-1">{{ hiddenStr(item.fullName) }}</div>
                <div class="flex align-center " style="width: 120px;">
                  <div class="label">已上传：</div>
                  <div class="value">{{ item.uploadNum }}个模型</div>
                </div>
                <div class="flex align-center" style="width: 100px;">
                  <div class="label">已瓜分：</div>
                  <div class="value" style="color:#FA5C5C;">¥{{ item.totalMoney }}.00</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="jd-box" class="jd-box flex flex-direction align-center" style="padding-top: 30px">
        <img style="width: 64px;" src="../assets/gfMoney/title-jd.png">
        <div class="hy-list">
          <div class="invite-num">好友任务进度 <span style="font-weight: normal;color:#999999;margin-left: 28px"
              v-if="GET_USER_INFO.token">{{ inviteNum }}/10</span></div>
          <div class="flex flex-wrap align-center justify-between" style="position: relative">
            <div class="invite-item" v-for="(item, index) in inviteList" :key="index">
              <div class="flex align-center justify-between">
                <div class="flex align-center">
                  <el-avatar v-if="item.fullName" :size="30" icon="el-icon-user-solid"
                    :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
                  <i style="font-size: 30px;color: #E5E5E5 " v-else class="el-icon-circle-plus"></i>
                  <div class="username text-line-1" style="margin-left: 9px">{{ item.fullName ? item.fullName : '待邀请' }}
                  </div>
                </div>
                <div class="money-jl" v-if="item.missionStep == 2">邀请成功</div>
                <div class="money-jl" v-if="item.missionStep == 1">已注册</div>
              </div>
            </div>
            <div class="no-login-mask flex align-center justify-center" v-if="!GET_USER_INFO.token">
              <div style="font-size: 14px;text-align: center;color: #FF0000;cursor: pointer">请登录后查看!</div>
              <el-button
                style="background-color: #FF0000;color: #FFFFFF;margin-left: 20px;border-radius: 20px;letter-spacing: 2px;font-weight: bold"
                @click="goLogin">登录</el-button>
            </div>
          </div>
        </div>
      </div>
      <div id="rule-box" class="rule-box flex flex-direction align-center" style="padding-top: 30px">
        <img style="width: 111px;" src="../assets/gfMoney/title-rule.png">
        <div class="rule-content" v-html="activityInfo.rule"></div>
      </div>
      <div class="footer">京ICP备19017914号-2</div>
    </div>

    <login-modal ref="loginModalRef" @loginSuccess="loginSuccess"></login-modal>

    <div class="close-modal flex align-center justify-center"
      v-if="showClosed && (!activityInfo.id || activityInfo.activityOpen != 1)">
      <div class="close-info-text">活动未开始或已结束！如有疑问，请联系网站客服!</div>
    </div>
  </div>
</template>

<script >
import { getBannerApi } from "@/api/user";
import { getActivityInfo, getRankTotalApi, getRankWeekApi, getRankUploadApi, getAvUserInfoApi, getInvitedListApi } from "@/api/activity";
import { mapGetters, mapMutations } from "vuex";
import commonMixin from "@/mixins/commonMixin";
import moment from 'moment'
import LoginModal from "@/components/LoginModal";

export default {
  components: { LoginModal },
  mixins: [commonMixin],
  data () {
    return {
      activityInfo: {},
      bannerList: [],
      swiperBanner: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.banner-pagination'
        }
      },
      headerFixed: false,
      active: 1,
      totalRankList: [],
      weekRankList: [],
      uploadRankList: [],
      avUserInfo: {},
      inviteList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      inviteNum: 0,
      showClosed: false,
    }
  },
  created () {
    this.$store.state.IsHdPage = true
    this.getActivity();
    setInterval(() => {
      this.getActivity();
    }, 30000)
    this.getBanner();
  },
  beforeDestroy () {
    this.$store.state.IsHdPage = false
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapGetters(["GET_USER_INFO", "GET_CART_BADGE", "GET_BELL_BADGE",]),
    ...mapMutations({
      SET_USER_INFO: "SET_USER_INFO",
      SET_BUY_VISIBLE: "SET_BUY_VISIBLE",
    }),

    money () {
      return this.activityInfo.totalMoney - this.activityInfo.expendMoney - this.activityInfo.freezeMoney
    },
    prcentNum () {
      if (this.avUserInfo.currentMoney && this.activityInfo.txMoney) {
        return (this.avUserInfo.currentMoney / this.activityInfo.txMoney).toFixed(2) * 100 > 100 ? 100 : (this.avUserInfo.currentMoney / this.activityInfo.txMoney).toFixed(2) * 100
      } else {
        return 0
      }
    },
    showTx () {
      if (this.avUserInfo.currentMoney && this.activityInfo.txMoney && this.avUserInfo.currentMoney >= this.activityInfo.txMoney) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    loginSuccess () {
      this.getActivity();
    },
    toTx () {
      if (this.activityInfo.txOpen != 1) {
        return
      }
      if (this.GET_USER_INFO.token) {
        this.$router.push("/user/tx");
      } else {
        this.goLogin()
      }
    },
    hiddenStr (name) {
      let newStr;
      if (name.length === 2) {
        newStr = name.substr(0, 1) + '*';
      } else if (name.length > 2) {
        let char = '';
        for (let i = 0, len = name.length - 2; i < len; i++) {
          char += '*';
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1);
      } else {
        newStr = name;
      }
      return newStr;
    },
    copyInviteUrl () {
      if (this.GET_USER_INFO.token) {
        this.$copyText("快来！上传模型就能瓜分红包：http://cg.h8m.cn?inviteCode=" + this.GET_USER_INFO.inviteCode + "#/gfMoney").then(
          e => {
            this.$message.success("已复制邀请链接到剪贴板，使用浏览器/PC浏览器打开");
          }
        )
      }
    },
    moment,
    goFb () {
      if (this.GET_USER_INFO.token) {
        this.$router.push("/user/resource");
      } else {
        this.goLogin()
      }
    },
    getInvitedList () {
      getInvitedListApi({
        activityId: this.activityInfo.id
      }).then(res => {
        this.inviteList = res.data
        this.inviteNum = res.data.filter(item => item.missionStep == 3).length
        this.inviteNum = this.inviteNum > 10 ? 10 : this.inviteNum
        while (this.inviteList.length < 10) {
          this.inviteList.push({})
        }
      })
    },
    getAvUserInfo () {
      getAvUserInfoApi({
        activityId: this.activityInfo.id
      }).then(res => {
        this.avUserInfo = res.data
      })
    },
    getRankTotal () {
      getRankTotalApi({ activityId: this.activityInfo.id }).then(res => {
        this.totalRankList = res.data
      })
    },
    getRankWeek () {
      getRankWeekApi({ activityId: this.activityInfo.id }).then(res => {
        this.weekRankList = res.data
      })
    },
    getRankUpload () {
      getRankUploadApi({ activityId: this.activityInfo.id }).then(res => {
        this.uploadRankList = res.data
      })
    },
    getActivity () {
      getActivityInfo().then(res => {
        this.activityInfo = res.data
        if (this.activityInfo.id) {
          this.getRankTotal()
          this.getRankWeek()
          this.getRankUpload()
          if (this.GET_USER_INFO.token) {
            this.getAvUserInfo()
            this.getInvitedList()
          }
        } else {
          this.showClosed = true
        }
      })
    },
    toLucky () {
      if (this.GET_USER_INFO.token) {
        this.$router.push("/lucky");
      } else {
        this.goLogin()
      }
    },
    menuClick (i) {
      this.active = i
      switch (i) {
        case 1:
          document.getElementById('banner-swiper').scrollIntoView({ behavior: "smooth", block: 'center' });
          break
        case 2:
          document.getElementById('money-box').scrollIntoView({ behavior: "smooth", block: 'center' });
          break
        case 3:
          document.getElementById('mission-box').scrollIntoView({ behavior: "smooth", block: 'center' });
          break
        case 4:
          document.getElementById('tx-box').scrollIntoView({ behavior: "smooth", block: 'center' });
          break
        case 5:
          document.getElementById('jd-box').scrollIntoView({ behavior: "smooth", block: 'center' });
          break
        case 6:
          document.getElementById('rule-box').scrollIntoView({ behavior: "smooth", block: 'center' });
          break
      }
    },
    //吸顶组件方法
    handleScroll () {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 700) {
        this.headerFixed = true;
      } else {
        this.headerFixed = false;
      }
      if (scrollTop >= 700 && scrollTop < 1400) {
        this.active = 2
      }
      if (scrollTop >= 1400 && scrollTop < 2000) {
        this.active = 3
      }
      if (scrollTop >= 2000 && scrollTop < 3100) {
        this.active = 4
      }
      if (scrollTop >= 3100 && scrollTop < 4000) {
        this.active = 5
      }
      if (scrollTop >= 4000) {
        this.active = 6
      }
    },
    goBanner (item) {
      // if (item.type == 2) {
      //   window.open(item.jumpUrl, '_blank')
      // }
    },
    getBanner () {
      getBannerApi({ position: 5 }).then(res => {
        if (res.code == 200) {
          this.bannerList = res.data;
        }
      });
    },
    goLogin () {
      this.$refs.loginModalRef.showModal()
    }
  },

};
  //吸顶效果

</script>

<style lang="less" scoped>
.close-modal {
  width: 100vw;
  height: 100vh;
  background-color: rgba(#000000, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
}

.little-screen {
  .close-info-text {
    color: #ffffff;
    font-size: 14px;
  }

  .footer {
    background-color: #1c6f6e;
    color: #fff;
    font-size: 13px;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }

  .top-box {
    background-color: #801414;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    height: 40px;

    .logo-icon {
      height: 30px;
      margin-left: 10px;
    }
  }

  .no-login-mask {
    position: absolute;
    z-index: 2;
    border-radius: 20px;
    background-color: rgba(#eeeeee, 0.9);
    width: 100%;
    height: 100%;
  }

  .rank-num {
    font-size: 10px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fa5c5c;
  }

  .tofb {
    width: 600px;
    height: 80px;
    background: #fa5c5c;
    border-radius: 40px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
    margin: 60px auto;
    cursor: pointer;
  }

  .rule-content {
    width: 345px;
    min-height: 150px;
    background: #ffffff;
    border-radius: 20px;
    overflow: auto;
    margin-top: 20px;
    padding: 20px;
  }

  .hy-list {
    font-size: 10px;
    width: 345px;
    min-height: 231px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 20px;
    padding: 10px;

    .invite-num {
      font-size: 10px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #363636;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 18px;
      padding-top: 10px;
    }

    .invite-item {
      width: 325px;
      height: 47px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 20px;
      margin-top: 10px;
      padding: 8px;
      cursor: pointer;

      .p-line {
        width: 325px;
        height: 10px;
        background: #ffebeb;
        border-radius: 5px;
        overflow: hidden;
      }

      .p-r-line {
        height: 10px;
        background: #fa5c5c;
      }

      .percent-text {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }

      .money-jl {
        width: 70px;
        height: 30px;
        background: #ffe0e0;
        border-radius: 4px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fa5c5c;
      }
    }
  }

  .tx-rank {
    width: 345px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 20px;
    padding: 16px;
    overflow: hidden;

    .s-line {
      width: 1px;
      height: 200px;
      margin-left: 20px;
    }

    .rank-list {
      margin-top: 20px;
      border-top: 1px solid #eeeeee;
      overflow: hidden;

      .rank-item {
        font-size: 10px;
        height: 60px;
        width: 100%;
        border-bottom: 1px solid #eeeeee;

        .username {
          font-size: 9px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #363636;
          margin-left: 8px;
          width: 60px;
        }

        .label {
          font-size: 8px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }

        .value {
          font-family: Microsoft YaHei;
          color: #363636;
          display: inline-block;
        }
      }
    }

    .rank-name {
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #4d4d4d;
      width: 50px;
    }
  }

  .headimg {
    width: 40px;
    height: 40px;
    background-color: #e5e5e5;
  }

  .notice {
    position: absolute;
    bottom: 0;
    width: 345px;
    height: 40px;
    background: #fff8e5;
    padding: 0 15px;
    border-radius: 0px 0px 20px 20px;
  }

  .prize-text {
    font-size: 10px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-decoration: underline;
    color: #1c6f6e;
  }

  .circle {
    width: 4px;
    height: 4px;
    background: #ff0000;
    border-radius: 50%;
    position: relative;
    top: -4px;
  }

  .tx-message {
    width: 300px;
    height: 35px;
    background: #fa5c5c;
    border-radius: 35px;
    font-size: 10px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 35px;
    text-align: center;
    margin-top: 30px;
  }

  .tx-message-tx {
    width: 300px;
    height: 35px;
    background: #fa5c5c;
    border-radius: 35px;
    font-size: 10px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 35px;
    text-align: center;
    margin-top: 30px;
    cursor: pointer;
    letter-spacing: 1px;
  }

  .line-box {
    width: 340px;
    height: 10px;
    background: #ffebeb;
    border-radius: 5px;
    margin-top: 75px;
    position: relative;

    .process-line {
      height: 5px;
      background: #fa5c5c;
      border-radius: 5px 0 0 5px;
    }

    .money-point {
      width: 80px;
      height: 25px;
      background: #ff0000;
      border-radius: 18px;
      position: absolute;
      font-size: 9px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 25px;
      text-align: center;
      top: -45px;

      .sj-sk {
        position: absolute;
        left: 35px;
        width: 0;
        height: 0;
        border-top: 9px solid #ff0000;
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
      }
    }

    .percent {
      width: 30px;
      height: 20px;
      background: #ffffff;
      box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.09);
      border-radius: 8px;
      position: absolute;
      top: -8px;
      font-size: 10px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      text-align: center;
    }
  }

  .menu-list {
    width: 151px;
    margin-left: 28px;
    padding-top: 195px;

    .menu-item {
      width: 151px;
      height: 50px;
      border: 3px solid #fffed0;
      border-radius: 8px;
      padding: 0 16px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ff533a;
      margin-bottom: 7px;
      cursor: pointer;
    }

    .menu-active {
      background: #fffed0;
    }

    .menu-default {
      background: #ffffff;
    }
  }

  .invite-copy {
    width: 135px;
    height: 50px;
    background: #fa5c5c;
    box-shadow: 0px 5px 5px 0px rgba(255, 100, 71, 0.26);
    border-radius: 0px 10px 10px 0px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }

  .invite-code-text {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #363636;
  }

  .invite-box {
    margin-top: 20px;
    width: 345px;
    height: 50px;
    background: #ffffff;
    border: 1px solid #fcaa97;
    box-shadow: 0px 5px 5px 0px rgba(255, 100, 71, 0.26);
    border-radius: 10px;
  }

  .sy-box {
    width: 300px;
    height: 40px;
    background: #fa5c5c;
    border-radius: 20px;
    margin-top: 30px;
    color: #ffffff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }

  .info-box {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;

    .title-img {
      width: 64px;
      margin-top: 18px;
    }
  }

  div {
    box-sizing: border-box;
  }

  .isFixed {
    position: fixed;
    width: 1920px;
    top: 50px;
    left: 0;
    z-index: 1000;
    transition: all 1s;
    transform: translateY(100px);
  }

  .noFixed {
    position: relative;
    z-index: 1000;
  }

  .menu-box {
    width: 207px;
    height: 551px;
    background-image: url("../assets/gfMoney/menu_back.png");
    background-size: 207px 551px;
    background-repeat: no-repeat;
  }

  .money-box {
    padding-top: 50px;
    width: 100%;
    height: 360px;
    background-image: url("../assets/gfMoney/money_back.png");
    background-size: 100% 730px;
    background-repeat: no-repeat;
    position: relative;
  }

  .mission-box {
    width: 100%;
    height: 330px;
    background-image: url("../assets/gfMoney/mission_back.png");
    background-size: 100% 360px;
    background-repeat: no-repeat;
    position: relative;
    padding-bottom: 20px;

    .mission-in-box {
      margin-top: 20px;
      width: 345px;
      height: 300px;
      background: #ffffff;
      border-radius: 20px;
      position: relative;
    }

    .mission-title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      margin-top: 32px;
    }
  }

  .banner-swiper {
    width: 100%;
    background-color: #000000;
    height: 700px;

    .banner-swiper-item {
      width: 100%;
      height: 700px;

      .banner-swiper-item-box {
        width: 100%;
        height: 700px;

        .banner-img {
          width: 100%;
          height: 700px;
          background-size: cover;
          background-position: center;
        }
      }
    }

    .banner-pagination {
      position: absolute;
      z-index: 9;
      text-align: center;
    }
  }
}

.gfmoney-box {
  min-width: 1200px;
  background-color: #fffbf2;
  position: relative;

  .close-info-text {
    color: #ffffff;
    font-size: 30px;
  }

  .no-login-mask {
    position: absolute;
    z-index: 2;
    border-radius: 20px;
    background-color: rgba(#eeeeee, 0.9);
    width: 100%;
    height: 100%;
  }

  .rank-num {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fa5c5c;
  }

  .tofb {
    width: 600px;
    height: 80px;
    background: #fa5c5c;
    border-radius: 40px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
    margin: 60px auto;
    cursor: pointer;
  }

  .rule-content {
    width: 1000px;
    min-height: 289px;
    background: #ffffff;
    border-radius: 20px;
    overflow: auto;
    margin-top: 40px;
    padding: 40px;
    line-height: 2rem;
  }

  .hy-list {
    width: 1000px;
    min-height: 431px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 61px;
    padding: 22px;

    .invite-num {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #363636;
      width: 959px;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 18px;
    }

    .invite-item {
      width: 470px;
      height: 122px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 20px;
      margin-top: 20px;
      padding: 22px 16px;

      .p-line {
        width: 450px;
        height: 10px;
        background: #ffebeb;
        border-radius: 5px;
        overflow: hidden;
      }

      .p-r-line {
        height: 10px;
        background: #fa5c5c;
      }

      .percent-text {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }

      .money-jl {
        width: 70px;
        height: 30px;
        background: #ffe0e0;
        border-radius: 4px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fa5c5c;
      }
    }
  }

  .tx-rank {
    width: 1000px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 42px;
    padding: 32px;

    .s-line {
      width: 1px;
      height: 404px;
      margin-left: 40px;
    }

    .rank-list {
      width: 614px;
      height: 404px;
      margin-left: 27px;
      border-top: 1px solid #eeeeee;

      .rank-item {
        height: 80px;
        width: 100%;
        border-bottom: 1px solid #eeeeee;

        .username {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #363636;
          margin-left: 16px;
          width: 150px;
        }

        .label {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }

        .value {
          font-family: Microsoft YaHei;
          color: #363636;
          width: 100px;
          display: inline-block;
        }
      }
    }

    .rank-name {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #4d4d4d;
      width: 90px;
    }
  }

  .headimg {
    width: 40px;
    height: 40px;
    background-color: #e5e5e5;
  }

  .notice {
    position: absolute;
    bottom: 0;
    width: 1000px;
    height: 80px;
    background: #fff8e5;
    padding: 0 34px;
    border-radius: 0px 0px 20px 20px;
  }

  .prize-text {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-decoration: underline;
    color: #1c6f6e;
  }

  .circle {
    width: 8px;
    height: 8px;
    background: #ff0000;
    border-radius: 50%;
    position: relative;
    top: -8px;
  }

  .tx-message {
    width: 600px;
    height: 70px;
    background: #fa5c5c;
    border-radius: 35px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 70px;
    text-align: center;
    margin-top: 75px;
  }

  .tx-message-tx {
    width: 600px;
    height: 70px;
    background: #fa5c5c;
    border-radius: 35px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 70px;
    text-align: center;
    margin-top: 75px;
    cursor: pointer;
    letter-spacing: 1px;
  }

  .line-box {
    width: 700px;
    height: 10px;
    background: #ffebeb;
    border-radius: 5px;
    margin-top: 158px;
    position: relative;

    .process-line {
      height: 10px;
      background: #fa5c5c;
      border-radius: 5px 0 0 5px;
    }

    .money-point {
      width: 93px;
      height: 44px;
      background: #ff0000;
      border-radius: 18px;
      position: absolute;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      top: -70px;

      .sj-sk {
        position: absolute;
        left: 42px;
        width: 0;
        height: 0;
        border-top: 9px solid #ff0000;
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
      }
    }

    .percent {
      width: 50px;
      height: 30px;
      background: #ffffff;
      box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.09);
      border-radius: 8px;
      position: absolute;
      top: -10px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 30px;
      text-align: center;
    }
  }

  .menu-list {
    width: 151px;
    margin-left: 28px;
    padding-top: 195px;

    .menu-item {
      width: 151px;
      height: 50px;
      border: 3px solid #fffed0;
      border-radius: 8px;
      padding: 0 16px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ff533a;
      margin-bottom: 7px;
      cursor: pointer;
    }

    .menu-active {
      background: #fffed0;
    }

    .menu-default {
      background: #ffffff;
    }
  }

  .invite-copy {
    width: 273px;
    height: 100px;
    background: #fa5c5c;
    box-shadow: 0px 5px 5px 0px rgba(255, 100, 71, 0.26);
    border-radius: 0px 20px 20px 0px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }

  .invite-code-text {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #363636;
  }

  .invite-box {
    margin-top: 65px;
    width: 960px;
    height: 100px;
    background: #ffffff;
    border: 1px solid #fcaa97;
    box-shadow: 0px 5px 5px 0px rgba(255, 100, 71, 0.26);
    border-radius: 20px;
  }

  .sy-box {
    width: 600px;
    height: 80px;
    background: #fa5c5c;
    border-radius: 40px;
    margin-top: 37px;
    color: #ffffff;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }

  .info-box {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;

    .title-img {
      width: 127px;
      margin-top: 76px;
    }
  }

  div {
    box-sizing: border-box;
  }

  .isFixed {
    position: fixed;
    width: 1920px;
    top: 50px;
    left: 0;
    z-index: 1000;
    transition: all 1s;
    transform: translateY(100px);
  }

  .noFixed {
    position: relative;
    z-index: 1000;
  }

  .menu-box {
    width: 207px;
    height: 551px;
    background-image: url("../assets/gfMoney/menu_back.png");
    background-size: 207px 551px;
    background-repeat: no-repeat;
  }

  .money-box {
    padding-top: 50px;
    width: 100%;
    height: 730px;
    background-image: url("../assets/gfMoney/money_back.png");
    background-size: 100% 730px;
    background-repeat: no-repeat;
    position: relative;
  }

  .mission-box {
    width: 100%;
    height: 730px;
    background-image: url("../assets/gfMoney/mission_back.png");
    background-size: 100% 730px;
    background-repeat: no-repeat;
    position: relative;

    .mission-in-box {
      margin-top: 63px;
      width: 1000px;
      height: 511px;
      background: #ffffff;
      border-radius: 20px;
      position: relative;
    }

    .mission-title {
      height: 32px;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 48px;
      margin-top: 76px;
    }
  }

  .banner-swiper {
    width: 100%;
    height: 700px;

    .banner-swiper-item {
      width: 100%;
      height: 700px;

      .banner-swiper-item-box {
        width: 100%;
        height: 700px;

        .banner-img {
          width: 100%;
          height: 700px;
          background-size: cover;
          background-position: center;
        }
      }
    }

    .banner-pagination {
      position: absolute;
      z-index: 9;
      text-align: center;
    }
  }
}</style>
